import {
  CodeVerificationSession,
  PhoneNumber,
} from "~/common/types/verificationCode";

export const DEFAULT_CODE_LENGTH = 6;

export const CODE_VERIFICATION_CHANNELS = {
  SMS: "sms",
};

export const CODE_VERIFICATION_SCOPES = {
  SIGNUP: "signup",
  LOGIN: "login",
  VERIFICATION: "verification",
  PHONE_UPDATE: "phone_update",
};

export const COUNTRY_CODES = {
  US: "+1",
};

export const INITIAL_VERIFICATION_SESSION: CodeVerificationSession = {
  canResendAt: null,
  token: null,
  isExpired: false,
} as const;

export const INITIAL_PHONE_NUMBER: PhoneNumber = {
  country_code: "+1",
  number: "",
};
